import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox", "aria-label"]
const _hoisted_2 = ["href"]

import { useAttrs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    svg: {},
    ariaLabel: {}
  },
  setup(__props: any) {


const attr = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    viewBox: _ctx.svg.viewBox
  }, _unref(attr), {
    role: "img",
    "aria-label": _ctx.ariaLabel
  }), [
    _createElementVNode("use", {
      href: `#${_ctx.svg.id}`
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})